import { useCallback, useState } from 'react';

export const useCompletedStepCodes = () => {
  const [completedStepCodes, setCompletedStepCodes] = useState(() => new Set());

  const markStepCompleted = useCallback((stepCode) => {
    if (!stepCode) return;
    setCompletedStepCodes((prev) => {
      if (prev.has(stepCode)) return prev;
      const next = new Set(prev);
      next.add(stepCode);
      return next;
    });
  }, []);

  const unmarkStepCompleted = useCallback((stepCode) => {
    if (!stepCode) return;
    setCompletedStepCodes((prev) => {
      if (!prev.has(stepCode)) return prev;
      const next = new Set(prev);
      next.delete(stepCode);
      return next;
    });
  }, []);

  return { completedStepCodes, markStepCompleted, unmarkStepCompleted };
};
